const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{eID} .text-edit',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-1',
  settingGroups: {
    [globalStyleId]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'line-height': {
        ...defaultSelector,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      'letter-spacing': {
        ...defaultSelector,
        inherit: 'text.letterSpacing',
        cssAttr: 'letter-spacing',
        listUnit: 'px',
      },
      // "text-color": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
  },
};

export const TEXT_BLOCK_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'paragraph',
  },
];
